module.exports = __webpack_public_path__ + "static/big2-e5f2b3c0ae363161c51d6fa9b8f88dfa.png";